import CookieConsentSettingsPage from './CookieConsentSettingsPage';

export const components = {
  CookieConsentSettingsPage,
};
